export enum BikeType {
    M_CARGO = "M_CARGO", 
    E_CARGO = "E_CARGO", 
    CHILD = "CHILD", 
    MECHANICAL = "MECHANICAL", 
    ELECTRICAL = "ELECTRICAL", 
    UNDEFINED = "UNDEFINED"
}



// WEBPACK FOOTER //
// ./src/app/models/bike-type.enum.ts